let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eqI14")).then(() => parcelRequire('8FtQT'));